import { combineReducers, Reducer } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { IAction } from 'src/js/actions/IshAction';
import { preferencesReducer } from '../common/reducers/Preferences';
import { configReducer } from '../common/reducers/Reducer';
import { Reducer as CheckoutReducer } from '../enrol/reducers/Reducer';
import { IshState } from '../services/IshState';
import { cartReducer } from '../web/reducers/cart';
import { coursesReducer, inactiveCoursesReducer, waitingCoursesReducer } from '../web/reducers/courses';
import { productsReducer } from '../web/reducers/products';
import { suggestionsReducer } from '../web/reducers/suggestions';
import popup from './popup';

export const combinedReducers: Reducer<IshState,IAction> = combineReducers({
  popup,
  form: formReducer,
  cart: cartReducer,
  courses: coursesReducer,
  products: productsReducer,
  waitingCourses: waitingCoursesReducer,
  inactiveCourses: inactiveCoursesReducer,
  checkout: CheckoutReducer,
  config: configReducer,
  preferences: preferencesReducer,
  suggestions: suggestionsReducer
});